<template>
  <div class="chart-header">
    <div class="chart-left">
      <span class="chart-title">{{ title }}</span>
      <Popover
        width="200"
        :content="content"
        trigger="hover"
      >
        <i
          slot="reference"
          style="color: #9ca6c0; margin-left: 6px; cursor: pointer;"
          class="el-icon-question"
        />
      </Popover>
    </div>
    <div class="chart-left">
      <RadioGroup
        v-model="sum"
        class="chart-radio"
        size="mini"
        @change="handleChange"
      >
        <RadioButton :label="1">MTD</RadioButton>
        <RadioButton :label="0">三天</RadioButton>
      </RadioGroup>
      <i
        v-if="sum === 0"
        class="crm-icon-zoom-in chart-expand"
        @click="handleExpand"
      />
    </div>
  </div>
</template>

<script>
import { RadioGroup, RadioButton, Popover } from 'element-ui';

export default {
  components: {
    RadioGroup,
    RadioButton,
    Popover,
  },

  props: {
    title: {
      type: String,
      required: true,
    },

    content: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      sum: 0,
    };
  },

  methods: {
    handleChange() {
      this.$emit('change', this.sum);
    },

    handleExpand() {
      this.$emit('expand');
    },
  },
};
</script>

<style lang="less" scoped>
.chart {
  width: 362px;
  height: 370px;
  box-sizing: border-box;

  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &-left {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &-title {
    font-size: 18px;
    font-weight: 600;
    color: rgba(48, 49, 51, 1);
    line-height: 18px;
  }

  &-radio {
    margin-right: 12px;
  }

  &-expand {
    font-size: 18px;
    color: #9ca6c0;
    cursor: pointer;
  }
}
</style>